import cx from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import styles from './OMSegmentedControl.scss';

const OMSegmentedControl = (props) => {
  const { values, name, selectedValue, className, inReduxForm, onChange, theme = '' } = props;
  const handleChange = (evt) => {
    const { value } = evt.target;
    onChange(value);
  };

  return (
    <div
      className={cx(
        styles.segmentedWrapper,
        className,
        styles[theme]
      )}
    >
      { values.map(({ value, label }) => (
        <div
          className={cx(
            styles.segmentedButton,
            { [styles.active]: selectedValue == value }, // eslint-disable-line eqeqeq
            { [styles.twoInRow]: values.length === 2 }
          )}
          key={label}
        >
          { inReduxForm
            ? (<Field
              name={name}
              component="input"
              type="radio"
              value={value}
              id={`${name}-${value}`}
              onChange={onChange}
            />)
            : (<input
              name={name}
              type="radio"
              value={value}
              id={`${name}-${value}`}
              onChange={handleChange}
            />)
          }
          <label htmlFor={`${name}-${value}`}>{label}</label>
        </div>
      ))}
    </div>
  );
};

OMSegmentedControl.propTypes = {
  values: PropTypes.array,
  name: PropTypes.string,
  selectedValue: PropTypes.number,
  className: PropTypes.string,
  inReduxForm: PropTypes.bool,
  onChange: PropTypes.func,
  theme: PropTypes.oneOf(['green', 'gray'])
};

export default OMSegmentedControl;
